import { BreadCrumbs } from '@common';
import { Box, Stack, Title } from '@mantine/core';
import styles from './PageLayout.module.css';

type PageLayoutPropsType = {
  title: React.ReactNode;
  children?: React.ReactNode;
};

export const PageLayout: React.FC<PageLayoutPropsType> = ({
  title,
  children,
}) => {
  return (
    <div className={styles.content}>
      <Stack gap="lg" flex={1} bg="layout.2" align="center">
        <Box
          className={styles.contentHeaderBackground}
          w="100%"
          h={125}
          px={34}
          py={22}
        />
        <Box
          flex={1}
          w="100%"
          px="sm"
          style={{
            marginTop: -131,
          }}
        >
          <Box px={24} py={8} mb={8}>
            <Title order={1} c="text.0">
              {title}
            </Title>
            <BreadCrumbs />
          </Box>
          <Box bg="white" px="md" style={{ borderRadius: '0.5rem' }}>
            {children}
          </Box>
        </Box>
      </Stack>
    </div>
  );
};
